import React, { useEffect, Fragment } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { bool, func, number, shape, string } from "prop-types";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";

import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";

import DepositOptions from "pages/deposits/_components/Options";
import EditableLabel from "pages/_components/fields/EditableLabel";

import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import MainContainer from "pages/_components/MainContainer";
import gaEventTracker, { events } from "util/gaEventTracker";
import { isIOS } from "react-device-detect";
import { actions as productsActions } from "reducers/products";
import DepositDetailList from "./_components/DepositDetailList";
import DepositsHead from "./_components/DepositsHead";
import { renewalActions } from "./constants";
import DepositAction from "./_components/DepositAction";

const Details = (props) => {
    const {
        dispatch,
        match,
        selectedDeposit,
        fetching,
        // noDepositFound,
        depositsLength,
        toggleOptions,
        isMobile,
        isDesktop,
    } = props;

    const hasAutoRenewal = renewalActions.includes(selectedDeposit?.autoRenewal);
    const addButtonDisabled = () => selectedDeposit?.dateInvalid || !hasAutoRenewal;

    useEffect(() => {
        if (!depositsLength) {
            dispatch(depositsActions.listDeposits());
        }
        dispatch(depositsActions.readDeposit(match.params.id));
    }, [depositsLength, match.params.id]);

    useEffect(
        () => () => {
            if (isDesktop) {
                dispatch(depositsActions.cleanSelectedDeposit());
            }
        },
        [],
    );

    const handleDownloadClick = () => {
        gaEventTracker.triggerEvent(events.pf_detalle_descargar());
        dispatch(depositsActions.downloadDeposit(selectedDeposit, "pdf"));
    };

    const handleCancelAutoRenewal = () => {
        dispatch(push(`/deposits/${match.params.id}/cancelRenewal`));
    };

    const handleCloseOptions = () => {
        if (toggleOptions.length) {
            dispatch(depositsActions.toggleOptions([]));
        }
    };

    const handleSave = (alias) => {
        dispatch(productsActions.changeProductAlias(alias, match.params.id));
    };

    return (
        <PageLoading loading={fetching}>
            {selectedDeposit && (
                <Fragment>
                    <Notification scopeToShow="deposit/details" />
                    <DepositsHead
                        titleText={
                            selectedDeposit.productAlias ? selectedDeposit.productAlias : selectedDeposit.depositNumber
                        }
                        depositNumber={selectedDeposit.depositNumber}
                        backLinkTo="/deposits"
                        linkTo="/form/edit"
                        linkText="global.edit"
                        addLinkToLabel="deposits.cancelAutoRenewalNew"
                        addLinkTo={`/deposits/${match.params.id}/cancelRenewal`}
                        addButtonDisabled={addButtonDisabled()}
                        exportList="true"
                        autoLabelFlag={hasAutoRenewal ? "true" : ""}
                        editable
                        className={isIOS ? "deposit-head deposit-head-ios" : "deposit-head"}
                        handleClick={() => handleDownloadClick()}
                        idDeposit={match.params.id}
                    />
                    <MainContainer>
                        <div className="container">
                            {isMobile && (
                                <div className="grid-table box box-primary deposit-detail-info">
                                    <div className="grid-table-row">
                                        <div className="grid-table-data acct-number-label toolbar-item">
                                            <I18n id="deposits.certificateTitle" />
                                        </div>
                                        <div className="grid-table-data acct-number toolbar-item">
                                            <strong>
                                                <I18n id="global.number" /> {`${selectedDeposit.depositNumber}`}
                                            </strong>
                                        </div>
                                        {hasAutoRenewal && (
                                            <div className="grid-table-data auto-label-flag justify-end">
                                                <div className="tag tag-success">
                                                    <I18n id="deposits.expirationLabel.auto" />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {isDesktop && (
                                        <EditableLabel
                                            isDesktop={isDesktop}
                                            onSave={handleSave}
                                            value={
                                                selectedDeposit.productAlias
                                                    ? selectedDeposit.productAlias
                                                    : selectedDeposit.depositNumber
                                            }
                                        />
                                    )}
                                </div>
                            )}
                            <DepositDetailList deposit={selectedDeposit} {...props} />
                            <GridTable className="box info mt-4 mb-8 details">
                                <GridTable.Container>
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <CustomData
                                            icon="information_fill.svg"
                                            titleText="deposits.bankText"
                                            titleTextType="I18N"
                                            keepSpaceIfNoValue={false}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </div>
                    </MainContainer>
                    {!isDesktop && (
                        <>
                            <DepositOptions options={toggleOptions} handleClose={handleCloseOptions}>
                                <Button disabled={addButtonDisabled()} onClick={handleCancelAutoRenewal}>
                                    <I18n id="deposits.cancelAutoRenewalNew" />
                                </Button>
                                <DepositAction
                                    disabled
                                    isDesktop={isDesktop}
                                    labelKey="global.download"
                                    handleClick={() => {}}
                                />
                            </DepositOptions>
                        </>
                    )}
                </Fragment>
            )}
        </PageLoading>
    );
};

Details.propTypes = {
    selectedDeposit: shape({}).isRequired,
    // noDepositFound: bool.isRequired,
    depositsLength: number.isRequired,
    fetching: bool.isRequired,
    match: shape().isRequired,
    dispatch: func.isRequired,
    toggleOptions: shape([]).isRequired,
    isMobile: bool.isRequired,
    isDesktop: bool.isRequired,
    depositNumber: string.isRequired,
};

const mapStateToProps = (state) => ({
    selectedDeposit: depositsSelectors.getSelectedDeposit(state),
    // noDepositFound: depositsSelectors.getNoDepositFound(state),
    depositsLength: depositsSelectors.getDepositsLength(state),
    fetching: depositsSelectors.getFetching(state),
    deposits: depositsSelectors.getDeposits(state),
    toggleOptions: depositsSelectors.getToggleOptions(state),
});

export default connect(mapStateToProps)(Details);
